import { register } from 'extendable-media-recorder'
import { connect } from 'extendable-media-recorder-wav-encoder'

let initialized = false
let initPromise: Promise<void> | null = null

/**
 * Initialize the WAV encoder for extendable-media-recorder.
 * Safe to call multiple times - only initializes once.
 */
export async function initAudioEncoder(): Promise<void> {
  if (initialized) return

  if (!initPromise) {
    initPromise = (async () => {
      try {
        await register(await connect())
        initialized = true
        console.log('Audio encoder initialized (WAV support enabled)')
      } catch (error) {
        console.error('Failed to initialize audio encoder:', error)
        throw error
      }
    })()
  }

  return initPromise
}
